import React from 'react';
import PropTypes from 'prop-types';

import { DateTimeFormat } from '@febos-io/design';
import ListExamElementReport from './ListExamElementReport';

export function CardInfoExam({
  exam
}) {
  return (
    <div className="list-group">
      <div
        key={exam.name}
        role="button"
        className="card py-0 pt-2 list-group-item"
        aria-current="true"
      >
        <div className="card-body p-0">
          <div className="row">
            <div className="col-9">
              <h5 className="card-title">{exam.name}</h5>
            </div>
            <div className="col-3 text-end">
              <DateTimeFormat value={exam.createdAt} />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <ListExamElementReport
                exam={exam}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CardInfoExam;

CardInfoExam.propTypes = {
  exam: PropTypes.object
};
